<template>
  <div class="headerWrapper" ref="headerWrapper">
    <div class="header">
      <img src="../assets/icon128.png" alt="自选基金助手" />
      <h2 class="title">自选基金助手</h2>
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo menu"
        :router="true"
        @select="sltMenu"
        mode="horizontal"
      >
        <el-menu-item index="/Main" route="/Main">首页</el-menu-item>
        <el-menu-item index="/Download" route="/Download">下载</el-menu-item>
        <el-menu-item index="/Directions" route="/Directions"
          >使用说明</el-menu-item
        >
        <el-menu-item index="/QA" route="/QA"
          >常见问题</el-menu-item
        >
        <el-menu-item index="/ChangeLog" route="/ChangeLog"
          >更新日志</el-menu-item
        >
      </el-menu>
      <el-dropdown class="dropdown" trigger="click" @command="handleCommand">
        <el-button type="primary" plain icon="el-icon-menu"> </el-button>
        <el-dropdown-menu slot="dropdown" :divided="true">
          <el-dropdown-item divided command="/Main">首页</el-dropdown-item>
          <el-dropdown-item divided command="/Download">下载</el-dropdown-item>
          <el-dropdown-item divided command="/Directions"
            >使用说明</el-dropdown-item
          >
          <el-dropdown-item divided command="/QA"
            >常见问题</el-dropdown-item
          >
          <el-dropdown-item divided command="/ChangeLog"
            >更新日志</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        var headerMain = this.$refs.headerWrapper;
        var scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        var opcaity = scrollTop / 150 > 1 ? 1 : scrollTop / 150;
        headerMain.style.background = "rgba(255,255,255," + opcaity + ")";

        if (window.pageYOffset >= 150) {
          headerMain.classList.add("headerWrapper-shadow");
        } else {
          headerMain.classList.remove("headerWrapper-shadow");
        }
      };
    });
  },
  methods: {
    setSpot(...sendMsg) {
      try {
        window.TDAPP.onEvent(...sendMsg);
        return true;
      } catch (err) {
        return false;
      }
    },
    sltMenu(val) {
      this.setSpot("点击菜单", "点击菜单", { 菜单: val });
    },
    handleCommand(val) {
      this.setSpot("点击菜单", "点击菜单", { 菜单: val });
      this.$router.push(val).catch((err) => {
        err;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.headerWrapper {
  position: fixed;
  z-index: 1000;
  width: 100%;
  top: 0;
  left: 0;
}
.headerWrapper-shadow {
  box-shadow: 0 0 7px #bbb;
}
.header {
  background: none;
  margin: 0 auto;
  max-width: 1140px;
  height: 60px;
  width: 100%;
  margin: 0 auto;
  position: relative;

  & > img {
    width: 34px;
    left: 20px;
    top: 13px;
    outline: none;
    position: absolute;
  }
  .title {
    position: absolute;
    left: 65px;
    top: 0px;
    font-size: 24px;
    line-height: 60px;
    margin: 0;
    outline: none;
    color: #477dfd;
  }

  .dropdown {
    line-height: 60px;
    position: absolute;
    right: 20px;
    top: 0;
    .el-button {
      font-size: 22px;
      padding: 8px;
    }
  }
}

.el-menu-demo {
  padding-left: 230px;
  text-align: right;
  background: none;

  .el-menu-item {
    float: none;
    display: inline-block;
    padding: 0 15px;
    font-size: 18px;
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal > .el-menu-item:hover,
.el-menu--horizontal > .el-menu-item:focus {
  background: none;
}

@media (min-width: 700px) {
  .dropdown {
    display: none;
  }
}
@media (max-width: 699px) {
  .menu {
    display: none;
  }
}
</style>
